<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar Permissões do Usuário
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Nome</th>
                <td>{{ user.name }}</td>
              </tr>
              <tr>
                <th>E-mail</th>
                <td>{{ user.email }}</td>
              </tr>
            </tbody>
          </table>

          <h4>Permissões Atuais</h4>
          <div class="permissions-list">
            <div
              v-for="(userRole, index) in assignedRoles"
              :key="userRole.id"
              class="permission-card"
            >
              {{ userRole.description }}
              <button @click="removeRole(index)" class="remove-btn">
                x
              </button>
            </div>
            <div v-if="assignedRoles.length == 0">
              Nenhuma permissão atribuída
            </div>
          </div>

          <h4 class="title">
            Adicionar Permissões
          </h4>
          <select class="form-control" v-model="selectedRole" @change="addRole">
            <option value="" disabled>
              Selecione uma permissão
            </option>
            <option v-for="adminRole in adminRoles" :key="adminRole.id" :value="adminRole">
              {{ adminRole.description }}
            </option>
          </select>

          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" @click="updateUserRole">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminUsersService from 'services/AdminUsersService';
import AdminRolesService from 'services/AdminRolesService';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inputError: null,
      adminRoles: [],
      assignedRoles: [],
      selectedRole: null,
    };
  },
  methods: {
    loadAdminRoles() {
      AdminRolesService.getAll()
        .then((result) => {
          this.adminRoles = result;
        });
    },

    loadUserRoles() {
      AdminUsersService.getUserRoles(this.user.id)
        .then((result) => {
          const roles = result.map(role => role.admin_role);
          this.assignedRoles = roles;
        });
    },

    addRole() {
      this.inputError = null;
      if (this.validRole()) {
        this.assignedRoles.push(this.selectedRole);
      } else {
        this.inputError = 'Permissão já adicionada ou inválida.';
      }
      this.selectedRole = null;
    },

    validRole() {
      const assignedRoleIds = this.assignedRoles.map(assignedRole => assignedRole.id);
      return !assignedRoleIds.includes(this.selectedRole.id);
    },

    removeRole(index) {
      this.inputError = null;
      this.assignedRoles.splice(index, 1);
    },

    updateUserRole() {
      const assignedRoleIds = this.assignedRoles.map(assignedRole => assignedRole.id);

      AdminUsersService.updateUserRole(this.user.id, assignedRoleIds)
        .then(() => {
          this.$alert.notifySuccess('Permissões atualizadas com sucesso!');
          this.$emit('close');
        })
        .catch((error) => {
          this.inputError = error?.response?.data?.message || 'Erro ao atualizar: contate o suporte.';
        })
        .finally(() => this.$loader.hide());
    },
  },
  mounted() {
    this.loadAdminRoles();
    this.loadUserRoles();
  },
};
</script>

<style scoped>
  .alert{
    margin-top: 3%;
  }

  .permission-card {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    padding: 5px 10px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 150px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
  }

  .permission-card:hover {
    background-color: #dee2e6;
  }

  .permissions-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .remove-btn {
    background-color: none;
    color: black;
    border: none;
    padding: 2px 8px;
    margin-left: 8px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }

  .remove-btn:hover {
    color: #ff0000;
  }

  .title{
    margin-top: 3%;
  }
</style>
